export default __webpack_public_path__ + "static/media/dark-message-icon.ec0ada22.svg";